import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  modals: React.ReactNode[];
} = {
  modals: [],
};

export const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    pushModal: (state, action) => {
      state.modals = [...state.modals, action.payload];
    },
    popModal: (state) => {
      const modals = [...state.modals];
      modals.pop();
      state.modals = modals;
    },
    resetModals: (state) => {
      state.modals = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { pushModal, popModal, resetModals } = modalsSlice.actions;

export default modalsSlice.reducer;
